import React from 'react'

import { Region } from '@enonic/react-components';

import SingleCourse from '/react4xp/components/pages/single-course'

import dayjs from 'dayjs'
import "dayjs/locale/en";
import "dayjs/locale/nb";

function Course({ image, title, description, course, location, duration, cost, requirements, apply, highlights, richText, contentBox, regions, language }) {
    dayjs.locale(language == 'en' ? 'en' : 'nb')
    return (
        <SingleCourse
            hero={{
                image: {
                    src: image?.src,
                    srcSmall: image?.srcSmall,
                    alt: image?.alt,
                },
                title: title,
                description: description,
                course: {
                    level: course?.level,
                    label: course?.label
                },
                location: location,
                duration: duration,
                cost: cost,
                requirements: requirements,
                apply: {
                    cta: apply?.cta,
                    text: apply?.text?.replace('<<deadline>>', apply?.deadline ? dayjs(apply?.deadline).format('D. MMMM') : '')
                }
            }}
            highlights={highlights}
            richText={richText}
            contentBox={ contentBox ? {
                boxColor: 'green-light',
                title: contentBox?.title,
                description: contentBox?.description,
                cta: contentBox?.cta
            } : null}
            internalRegion={<Region name={regions?.internal?.name} regionData={regions?.internal} />}
            bottomRegion={<Region name={regions?.bottom?.name} regionData={regions?.bottom} />}
        />
    )
}

export default (props) => <Course {...props} />
